module.exports = __webpack_public_path__ + "img/body-2-lg.2d860476.png";